import { h, defineComponent, VNodeChildren } from 'vue';
// @ts-ignore
import { BTag, BTaglist } from 'buefy/dist/esm/tag';

export type TagType = 'error' | 'warning' | 'neutral' | 'success' | 'primary' | 'purple';

export interface TagProps {
  type: TagType;
}

const messageTypes: Record<string, string> = {
  success: 'is-success',
  error: 'is-danger',
  warning: 'is-warning',
  neutral: 'is-default',
  primary: 'is-primary',
  purple: 'is-purple',
};

const decodeType = (msgType: TagType): string => {
  return messageTypes[msgType] || 'is-default';
};

export const Tag = defineComponent<TagProps>({
  name: 'Tag',
  props: ['type'],
  setup(props, context) {
    return function render() {
      return h(
        BTag,
        { class: 'is-inverted', props: { type: decodeType(props.type) } },
        context.slots.default?.(),
      );
    };
  },
});

export const tag = (type: TagType, content: VNodeChildren) => h(
  Tag,
  { props: { type } },
  content,
);

export const tags = (content: VNodeChildren) => h(
  BTaglist,
  content,
);
